import React from "react";
import { Badge } from "@/components/ui/badge";
import { Check, AlertTriangle, Clock, X, CircleDot } from "lucide-react";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ kind, children, className, ...rest }) => {
    const map = {
        verified: {
            icon: Check,
            classes: "border-primary/40 text-primary bg-primary/10",
        },
        partial: {
            icon: AlertTriangle,
            classes: "border-warn/40 text-warn bg-warn-bg",
        },
        pending: {
            icon: Clock,
            classes: "border-muted-foreground/40 text-muted-foreground bg-muted",
        },
        would_bet: {
            icon: CircleDot,
            classes: "bg-primary text-primary-foreground border-primary",
        },
        would_pass: {
            icon: X,
            classes: "border-border text-muted-foreground bg-transparent",
        },
        hit: {
            icon: Check,
            classes: "bg-ok text-white border-ok",
        },
        miss: {
            icon: X,
            classes: "bg-fail/80 text-white border-fail",
        },
        neutral: {
            icon: CircleDot,
            classes: "border-border text-muted-foreground bg-transparent",
        },
    };
    const conf = map[kind] || map.neutral;
    const Icon = conf.icon;
    return (
        <Badge
            variant="outline"
            className={cn(
                "gap-1 h-5 px-1.5 py-0 text-[10px] font-medium tracking-wide uppercase rounded",
                conf.classes,
                className
            )}
            {...rest}
        >
            <Icon className="h-3 w-3" strokeWidth={2.5} />
            {children}
        </Badge>
    );
};
